const csvTemplate = `vat,reference,price
11,DE.SC-APD6ALL1,100000
11,DE.SC-APD12ALL1,200000
11,DE.SC-APN6ALL1,100000
10,DE.SC-APN12ALL1,200000`;

export default csvTemplate;
